import React, { useState, useEffect } from 'react';
import { Breadcrumb, Button, Col, Row } from "antd";
import Icofont from "react-icofont";
import { errorCatch, READWITH, QueryDetail, QueryParam, JSXMap, JSXPathMap, READ, IfElse, GET, QueryOrder, answersClearAll } from '../../components/Tool'
import { Link, Outlet, useParams } from 'react-router-dom';
import { useAuth, useNavigation } from '../../components/Auth';
import { Context, ServiceContext, SetContext, useUserContext } from '../../components/Context';
import moment from 'moment';
import Question from '../Question';

var _ = require('lodash');

function LineDescription(props) {
    const { title, value, unit, bold } = props;
    return (
        <div>
            <span style={(bold) ? { fontWeight: "600", fontSize: "18px" } : {}}>
                {title} {value} {unit}
            </span>
        </div>
    );
}
function Description(props) {
    const { title, value, unit } = props;
    return (
        <div>
            <div style={{ fontWeight: "600", fontSize: "18px" }}>
                {title}:
            </div>
            <div>
                {value} {unit}
            </div>
        </div>
    );
}
export default function Service(props) {
    let { id } = useParams();
    const auth = useAuth();
    const user = useUserContext();
    const navigation = useNavigation(); // navigation(-1) - goBack
    const [service, setService] = useState();
    const [context, setContext] = useState();
    
    useEffect(() => {
        // GET(auth, "/api/context/new",
        //     (res) => setContext(res.data),
        //     errorCatch
        // );
        GET(auth, "/api/context/last",
            (res) => setContext(res.data),
            errorCatch
        );
        READWITH(auth, "Services",
            [
                QueryDetail("model"),
                QueryParam("w-ID", id)
            ],
            (res) => setService(_.get(res, "data[0]")),
            errorCatch
        );
    }, []);

    return (<>
        <ServiceContext.Provider value={service}>
            <div style={{ padding: "0 24px" }}>
                <Breadcrumb style={{ margin: '16px 0' }}>
                    <Breadcrumb.Item>Сервисы</Breadcrumb.Item>
                    <Breadcrumb.Item>{_.get(service, 'name')}</Breadcrumb.Item>
                </Breadcrumb>
            </div>
            <div className="site-layout-background" style={{ padding: 24, minHeight: 360, height:"100%" }}>
                <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} style={{ paddingBottom: "12px" }}>
                    <Col className="gutter-row" span={24}>
                        <div className={"service-single s" + _.get(service, "ID")} style={{ padding: '8px 0' }}>
                            <div className="service-name">
                                <Icofont icon={_.get(service, 'icon')} style={{ fontSize: "22px", paddingRight: "5px" }} />
                                <span>{_.get(service, 'name')}</span>
                            </div>
                        </div>
                    </Col>
                </Row>
                <Context.Provider value={context}>
                    <SetContext.Provider value={setContext}>
                        {(!!context) && <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} style={{ paddingTop: "12px" }}>
                            <Col className="gutter-row" span={24} style={{ fontSize: "11px", color: "rgb(114 114 114)", display: "flex", justifyContent: "end" }}>
                                <div>
                                    <div>Заполняем отчет:</div>
                                    <div>
                                        <Icofont icon="at" style={{ paddingRight: "3px" }} />
                                        {moment(context.CreatedAt).format("HH:mm DD.MM.YYYY")}
                                    </div>
                                </div>
                            </Col>
                        </Row>}
                        <Outlet />
                    </SetContext.Provider>
                </Context.Provider>
            </div>
        </ServiceContext.Provider>
    </>);
}